
<!--
 * @Author: vince
 * @Date: 2021-09-03 14:34:32
 * @LastEditors: vince
 * @LastEditTime: 2021-09-08 10:03:43
 * @Description:
-->
<template>
	<div class="column">
		<div class="state-bar mb-2px">
			<div class="sys-tbh">教师获奖列表</div>
			<div class="space"></div>
			<el-button icon="el-icon-plus" type="primary" @click="onNew" size="small">新增</el-button>
		</div>
		<div style="flex:1">
			<el-table :loading="loading" :data="tableData" header-cell-class-name="tbh" style="width: 100%">
				<el-table-column prop="schoolName" label="校区" align="center"></el-table-column>
				<el-table-column prop="teacherName" label="获奖教师" align="center"></el-table-column>
				<el-table-column prop="title" label="获奖名称" align="center"></el-table-column>
				<el-table-column prop="ranks" label="获奖等级" align="center" :formatter="rankFormatter"></el-table-column>
				<el-table-column prop="classify" label="所属分类" align="center" :formatter="classifyFormatter"></el-table-column>
				<el-table-column prop="awardDate" label="获奖日期" align="center"></el-table-column>
				<el-table-column prop="photo" label="获奖照片" align="center">
					<template slot-scope="scope">
						<el-image fit="contain" v-if="scope.row.photo" class="photo" :src="scope.row.photo" :preview-src-list="scope.row.photoList"></el-image>
						<el-image v-else class="photo">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="id" label="操作" align="center">
					<template slot-scope="scope">
						<el-button @click="onEdit(scope.row)" type="text" size="small">编辑</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
							<el-button slot="reference" type="text" class="danger" size="small">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
				<pagination v-if="tableData.length>0" class="mb-md mr-md" slot="append" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :pageObj="filterForm"></pagination>
			</el-table>
		</div>
		<!-- <el-dialog title="编辑教师获奖" :visible.sync="dialog" @closed="onDialogClose">
			<el-form v-loading="saving" class="content-box" ref="elnewForm" :model="newForm" :rules="rules">
				<el-form-item label="奖项名称" prop="title">
					<el-input size="small" placeholder="请输入" v-model="newForm.title" show-word-limit maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="校区" prop="school">
					<school-selector dicType="module" :clearable="false" v-model="newForm.school" @change="schoolChange"></school-selector>
				</el-form-item>
				<el-form-item label="获奖教师" prop="teacher">
					<author-selector :schoolCodes="newForm.school?[newForm.school.schoolCode]:null" :multiple="false" v-model="newForm.teacher"></author-selector>
				</el-form-item>
				<el-form-item label="获奖等级" prop="rankTemp">
					<dicSelector dicType="awardlevel" v-model="newForm.rankTemp"></dicSelector>
				</el-form-item>
				<el-form-item label="获奖日期" prop="awardDate">
					<el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="newForm.awardDate"></el-date-picker>
				</el-form-item>
				<el-form-item label="获奖图片" prop="attach">
					<uploader v-if="dialog" tipDesc="仅支持图片" style="display:inline-block" list-type="picture-card" :multiple="true" :limit="10" accept="image/*" :maxSize="30*1024*1024" :file-list.sync="newForm.attach" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer text-center">
				<el-button @click="dialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="onSave" :loading="saving" size="small">确 定</el-button>
			</div>
		</el-dialog>-->

		<award-pop v-if="dialog" :dialog="dialog" :newPropForm="newForm" @changeHonorPop="changeHonorPop"></award-pop>
	</div>
</template>

<script>
import AwardPop from "@/components/common/AwardPop.vue";
import { mapGetters } from "vuex";
import pagination from "../../components/Pagination.vue";
import AuthorSelector from "../../components/school/authorSelector.vue";
import dicSelector from "../../components/school/dicSelector.vue";
import schoolSelector from "../../components/school/schoolSelector.vue";
import uploader from "../../components/school/uploader.vue";
import { getData, postData, postJson } from "../../http/fetch";

export default {
	name: "award",
	components: {
		AwardPop,
		uploader,
		pagination,
		dicSelector,
		AuthorSelector,
		schoolSelector
	},
	data() {
		return {
			saving: false,
			dialog: false,
			loading: false,
			filterForm: {
				current: 1,
				size: 10,
				total: 0,
				sizeList: [5, 10, 15, 20]
			},
			rankList: [],
			classifyList: [],
			tableData: [],
			newForm: {
				rankTemp: null,
				teacher: null,
				classify: null,
				id: null,
				infoCode: null,
				school: null,
				schoolCode: null,
				title: null,
				attach: [],
				awardDate: null,
				checkStatus:null
			},
			rules: {
				rankTemp: [
					{ required: true, message: "请选择获奖级别", trigger: "change" }
				],
				school: [{ required: true, message: "请输入分值", trigger: "change" }],
				teacher: [
					{ required: true, message: "请选择获奖教师", trigger: "change" }
				],
				title: [{ required: true, message: "请输入获奖名称", trigger: "blur" }],
				awardDate: [
					{ required: true, message: "请选择获奖日期", trigger: "blur" }
				]
			}
		};
	},
	computed: {
		...mapGetters(["schoolCode", "operatorId", "schoolCodes"])
	},
	created() {
		this.getDic("honorAwardType").then(res => {
			this.classifyList = res;
		});
		this.getDic("level").then(res => {
			this.rankList = res;
		});
	},
	mounted() {
		this.getList();
	},
	methods: {
		changeHonorPop(flag) {
			this.dialog = flag;
			this.getList();
		},
		schoolChange(e) {
			this.newForm.teacher = null;
		},
		rankFormatter(row, column, cellValue, index) {
			let result = cellValue;
			let find = this.rankList.find(f => f.dicCode == cellValue);
			if (find) {
				result = find.dicName;
			}
			return result;
		},
		classifyFormatter(row, column, cellValue, index) {
			let result = cellValue;
			let find = this.classifyList.find(f => f.dicCode == cellValue);
			if (find) {
				result = find.dicName;
			}
			return result;
		},
		getDic(dicType) {
			return new Promise((resolve, reject) => {
				getData("/core/dic/getDictionaryList", {
					dicType
				}).then(res => {
					if (res.length > 0) {
						res = res.map(m => {
							return {
								dicCode: m.dicCode,
								dicName: m.dicName
							};
						});
						resolve(res);
					} else {
						reject();
					}
				});
			});
		},
		getList() {
			this.loading = true;
			postJson("/teacherAwardInfo/getTeacherAward", {
				pageSize: this.filterForm.size,
				pageNum: this.filterForm.current,
				schoolCodes: this.schoolCodes
			})
				.then(res => {
					this.tableData = res.records
						? res.records.map(m => {
								let photoList = [];
								let photo = "";
								if (m.attach) {
									try {
										photoList = JSON.parse(m.attach).map(p => {
											return p.attachUrl;
										});
										photo = photoList[0];
									} catch (error) {}
								}
								m.photo = photo;
								m.photoList = photoList;
								return m;
						  })
						: [];
					this.filterForm.total = res.total;
				})
				.catch()
				.finally(() => {
					this.loading = false;
				});
		},
		onNew() {
			this.newForm = {
				rankTemp: null,
				teacher: null,
				classify: null,
				id: null,
				infoCode: null,
				school: null,
				schoolCode: null,
				title: null,
				attach: [],
				awardDate: null
			};
			this.dialog = true;
		},
		onDel(row) {
			this.loading = true;
			postData("/teacherAwardInfo/removeTeacherAward", {
				operatorId: this.operatorId,
				id: row.id
			})
				.then(res => {
					this.$message.success("删除成功！");
					this.getList();
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onEdit(row) {
			let attach = [];
			if (row.attach) {
				attach = JSON.parse(row.attach).map(m => {
					m.name = m.attachUrl;
					m.url = m.attachUrl;
					return m;
				});
			}
			this.newForm = {
				attach: attach,
				//awardDate: row.awardDate,
				classify: row.classify,
				id: row.id,
				infoCode: row.infoCode,
				ranks: row.ranks,
				schoolCode: row.schoolCode,
				teacherId: row.teacherId,
				teacherName: row.teacherName,
				checkStatus: row.checkStatus,
				title: row.title,
				unit: row.unit,
				school: {
					schoolCode: row.schoolCode
				},
				teacher: {
					userId: row.teacherId,
					userName: row.teacherName
				},
				rankTemp: {
					dicCode: `${row.ranks}`
				},
				levelTemp: {
					dicCode: `${row.level}`
				},
			};
			this.$set(this.newForm, "awardDate", row.awardDate);
			this.dialog = true;
			//this.$refs.elnewForm && this.$refs.elnewForm.resetFields();
		},
		// onSave() {
		// 	this.$refs.elnewForm.validate(valid => {
		// 		if (valid) {
		// 			this.saving = true;
		// 			let attach = this.newForm.attach.length
		// 				? JSON.stringify(
		// 						this.newForm.attach.map(m => {
		// 							return {
		// 								attachSize: m.attachSize,
		// 								attachType: m.attachType,
		// 								attachUrl: m.attachUrl
		// 							};
		// 						})
		// 				  )
		// 				: "";
		// 			postJson("/teacherAwardInfo/saveOrUpdateTeacherAward", {
		// 				attach: attach,
		// 				awardDate: this.newForm.awardDate,
		// 				classify: "award",
		// 				id: this.newForm.id ? this.newForm.id : null,
		// 				infoCode: this.newForm.infoCode ? this.newForm.infoCode : null,
		// 				operatorId: this.operatorId,
		// 				ranks: this.newForm.rankTemp.dicCode,
		// 				schoolCode: this.newForm.school.schoolCode,
		// 				teacherId: this.newForm.teacher.userId,
		// 				teacherName: this.newForm.teacher.userName,
		// 				title: this.newForm.title
		// 			})
		// 				.then(res => {
		// 					this.saving = false;
		// 					this.$message.success("保存成功！");
		// 					this.filterForm.current = 1;
		// 					this.getList();
		// 					this.dialog = false;
		// 				})
		// 				.catch()
		// 				.finally(() => {
		// 					this.saving = false;
		// 				});
		// 		}
		// 	});
		// },
		onDialogClose() {
			this.$refs.elnewForm.resetFields();
			this.newForm = {
				rankTemp: null,
				teacher: null,
				classify: null,
				id: null,
				infoCode: null,
				school: null,
				schoolCode: null,
				title: null,
				attach: [],
				awardDate: null,
				checkStatus:null
			};
		},
		//分页
		handleSizeChange(pageSize) {
			this.filterForm.current = 1;
			this.filterForm.size = pageSize;
			this.getList();
		},
		handleCurrentChange(curPage) {
			this.filterForm.current = curPage;
			this.getList();
		}
	}
};
</script>

<style lang='less'>
.photo {
	width: 60px;
	height: 60px;
	.image-slot {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		background: #f5f7fa;
		color: #909399;
		font-size: 14px;
	}
}
</style>
